__turbopack_context__.v({
  "code": "CodeEditorContent-module__c0WMZa__code",
  "codeBlock": "CodeEditorContent-module__c0WMZa__codeBlock",
  "container": "CodeEditorContent-module__c0WMZa__container",
  "header": "CodeEditorContent-module__c0WMZa__header",
  "headerActions": "CodeEditorContent-module__c0WMZa__headerActions",
  "name": "CodeEditorContent-module__c0WMZa__name",
  "switchContainer": "CodeEditorContent-module__c0WMZa__switchContainer",
});
